export const timestampFormatter = (timestamp) => {
    const date = new Date(parseInt(timestamp));

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

export const dateFormatter = (dateString) => {
    // const dateObj = new Date(dateString);

    // // Extract day, month, year, hours, minutes, and seconds
    // const day = String(dateObj.getDate()).padStart(2, '0');
    // const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    // const year = dateObj.getFullYear();
    // const hours = String(dateObj.getHours()).padStart(2, '0');
    // const minutes = String(dateObj.getMinutes()).padStart(2, '0');
    // const seconds = String(dateObj.getSeconds()).padStart(2, '0');
  
    // // Format the date
    // return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    if(dateString){
        const date = new Date(dateString);
      
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are 0-based
        const year = date.getUTCFullYear();
      
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');
      
        return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
    }
    return '';
}

export const convertMilliseconds = (milliseconds) => {
    const seconds = Math.floor(milliseconds / 1000); // Convert milliseconds to seconds
    const minutes = Math.floor(seconds / 60); // Convert seconds to minutes
    const hours = Math.floor(minutes / 60); // Convert minutes to hours
    
    const remainingSeconds = seconds % 60; // Remainder seconds after minutes
    const remainingMinutes = minutes % 60; // Remainder minutes after hours
  
    return {
      hours,
      minutes: remainingMinutes,
      seconds: remainingSeconds,
    };
};

export const showTimeInSec = (milliseconds) => {
    let showTime = '';

    const hours = convertMilliseconds(milliseconds).hours;
    const minutes = convertMilliseconds(milliseconds).minutes;
    const seconds = convertMilliseconds(milliseconds).seconds;

    // Conditionally append hours, minutes, and seconds if they are greater than 0
    if (hours > 0) showTime += `${hours} hours `;
    if (minutes > 0) showTime += `${minutes} minutes `;
    if (seconds > 0) showTime += `${seconds} seconds`;

    return showTime.trim();
}

// Same output as showTimeInSec, for values stored in SECONDS (e.g. meditation_time).
export const showTimeFromSeconds = (seconds) => showTimeInSec(Number(seconds) * 1000);

export const formatLastActive = (dateStr) => {
    // Input format: "2026-01-03 00:19:38"
    // Output format: "03/01/2026 00:19:38"
    if (!dateStr) return '-';
    const [datePart, timePart] = dateStr.split(' ');
    const [year, month, day] = datePart.split('-');
    return `${day}/${month}/${year} ${timePart}`;
};

/**
 * Convert date format from Y-m-d or Y-m-d H:i:s to d/m/Y or d/m/Y H:i:s without timezone conversion
 * Use this when the input is already in UTC and you just need to reformat
 * @param {string} dateString - Date string in 'Y-m-d' (e.g., '2026-01-23') or 'Y-m-d H:i:s' format (e.g., '2026-01-23 14:30:45')
 * @returns {string} Formatted date in 'd/m/Y' (e.g., '23/01/2026') or 'd/m/Y H:i:s' format (e.g., '23/01/2026 14:30:45')
 */
export const formatUTCDate = (dateString) => {
    if (!dateString) return '';

    // Split the date and time parts
    const parts = dateString.split(' ');
    const datePart = parts[0];
    const timePart = parts[1] || null;

    // Split the date into year, month, day
    const datePieces = datePart.split('-');
    if (datePieces.length !== 3) return dateString;

    const year = datePieces[0];
    const month = datePieces[1];
    const day = datePieces[2];

    // Return in d/m/Y format with optional time
    return timePart ? `${day}/${month}/${year} ${timePart}` : `${day}/${month}/${year}`;
};

/**
 * Convert ISO 8601 date format to d/m/Y H:i:s format (UTC already, no conversion)
 * @param {string} isoString - ISO 8601 date string in UTC (e.g., '2025-02-14T11:44:45.000Z')
 * @returns {string} Formatted date in 'd/m/Y H:i:s' format (e.g., '14/02/2025 11:44:45')
 */
export const formatISODate = (isoString) => {
    if (!isoString) return '';

    // Parse ISO string: 2025-02-14T11:44:45.000Z
    const datePart = isoString.split('T')[0]; // 2025-02-14
    const timePart = isoString.split('T')[1]?.split('.')[0]; // 11:44:45

    if (!datePart || !timePart) return '';

    // Split the date into year, month, day
    const [year, month, day] = datePart.split('-');

    // Return in d/m/Y H:i:s format
    return `${day}/${month}/${year} ${timePart}`;
};

/**
 * Convert ISO 8601 date format to d/m/Y H:i:s format in user's local timezone
 * @param {string} isoString - ISO 8601 date string in UTC (e.g., '2025-02-14T11:44:45.000Z')
 * @returns {string} Formatted date in 'd/m/Y H:i:s' format in local timezone (e.g., '14/02/2025 17:14:45')
 */
export const formatISODateToLocal = (isoString) => {
    if (!isoString) return '';

    const date = new Date(isoString);

    // Check if date is valid
    if (isNaN(date.getTime())) return '';

    // Get local date/time components (not UTC)
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
};

/**
 * Convert ISO 8601 date format to d/m/Y format (date only, no time)
 * @param {string} isoString - ISO 8601 date string in UTC (e.g., '2025-12-18T18:30:00.000Z')
 * @returns {string} Formatted date in 'd/m/Y' format (e.g., '18/12/2025')
 */
export const formatISODateOnly = (isoString) => {
    if (!isoString) return '';

    // Parse ISO string: 2025-12-18T18:30:00.000Z
    const datePart = isoString.split('T')[0]; // 2025-12-18

    if (!datePart) return '';

    // Split the date into year, month, day
    const [year, month, day] = datePart.split('-');

    // Return in d/m/Y format
    return `${day}/${month}/${year}`;
};



/**
 * Render a medicine_log value for display. The mobile app stores it as a JSON object
 * mapping a logged time to itself, e.g. {"12:15 AM":"12:15 AM"} (or several such
 * entries). Show the friendly list of times instead of the raw JSON; if a key and its
 * value ever differ, show "key → value". Non-JSON strings are shown as-is.
 * @param {string|object} raw
 * @returns {string}
 */
export const formatMedicineLog = (raw) => {
    if (raw == null || raw === '') return '—';

    let obj = raw;
    if (typeof raw === 'string') {
        const s = raw.trim();
        if (!s) return '—';
        try {
            obj = JSON.parse(s);
        } catch {
            return s; // not JSON — show the raw text
        }
    }

    if (typeof obj !== 'object' || obj === null) return String(obj);
    if (Array.isArray(obj)) {
        const items = obj.filter((v) => v != null && v !== '');
        return items.length ? items.join(', ') : '—';
    }

    const parts = Object.entries(obj).map(([k, v]) => (v == null || v === '' || String(v) === String(k) ? k : `${k} → ${v}`));
    return parts.length ? parts.join(', ') : '—';
};
